module.exports = __webpack_public_path__ + "img/img08.309bb93d.png";